export const appendValidatedParam = ({
  params,
  paramName,
  value,
}: {
  params: URLSearchParams
  paramName: string
  value: string | undefined
}) => {
  if (value) {
    // Chatgpt explanation:
    // \u00C0-\u017F covers most Latin-1 and Latin Extended-A Unicode characters, including all Norwegian, Swedish, Danish, German, French, and other Western European letters.
    // This lets users enter names, addresses, and comments with typical local characters.
    if (value.length > 1000 || !/^[\w\s<>&;,.!?()\-\u00C0-\u017F]*$/.test(value)) {
      throw new Error(`Invalid ${paramName}`)
    }
    params.append(paramName, value)
  }
}
